"use strict"

export class Dialog {
    
    constructor(cfg) {
        this.cfg=cfg;
    }
    
    render(box) {

        box.inner.innerHTML='';

        let header=document.createElement('h2');
        header.className="modal-title";
        try {
            header.innerText=this.cfg.head.toString();
        } catch(e) {};
        
        box.inner.appendChild(header);
        
        let body=document.createElement('div');
        body.className="modal-body";
        try {
            body.innerHTML=this.cfg.prompt.toString();
        } catch(e) {};
        
        box.inner.appendChild(body);        
        
        let buttons=(Array.isArray(this.cfg.buttons))?this.cfg.buttons:this.cfg.buttons?[this.cfg.buttons]:[];
        
        if (buttons.length) {
        
            let footer=document.createElement('div');
            footer.className="modal-footer";
            
            box.inner.appendChild(footer);

                   
            buttons.forEach((button)=>{
                if (button&&(typeof button === 'object')) {
                    let a=document.createElement(button.href?'a':'button');
                    a.className='btn btn-default'+(button.class?' '+button.class:'');
                    if (button.href) {a.href=button.href;}
                    if (button.blank) {a.target='_blank';}
                    a.innerText=button.name||'';
                    if (typeof button.callback=='function') {a.onclick=(even)=>{button.callback(event, box);}}
                    footer.appendChild(a);
                } else {console.error('VutBox.dialog: neplatný button:', button)}
                
            });
            
        }
        
    }
    
}